<template>
    <SPSProductAddressList v-editable="blok" :blok="blok" />
</template>

<script setup lang="ts">
defineProps({ blok: { type: Object } });
</script>

<style lang="postcss" scoped></style>
